var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.wb))]),_c('Divider'),_c('Editor',{model:{value:(_vm.wb),callback:function ($$v) {_vm.wb=$$v},expression:"wb"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }